import React from "react";
import { motion } from "framer-motion";

export const About = () => {
  return (
    <section id="about" className="relative py-24 lg:py-40 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-3">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-block h-2 w-2 bg-zinc-900" />
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
              About
            </span>
          </div>
          <p className="text-sm text-zinc-500">01 / 06</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-9"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-zinc-900">
            Strategy first.
            <br />
            <span className="text-zinc-400">Vanity metrics last.</span>
          </h2>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-10">
            <p className="text-lg text-zinc-600 leading-relaxed">
              I&rsquo;m a Digital Marketing Expert obsessed with one thing —
              <span className="text-zinc-900 font-semibold"> measurable ROI</span>.
              Over the last few years I&rsquo;ve helped startups, D2C brands,
              local businesses and service companies turn their digital
              presence into a revenue engine.
            </p>
            <p className="text-lg text-zinc-600 leading-relaxed">
              No buzzwords. No vanity dashboards. Just a clear plan, sharp
              creative, and channels that compound — built around your
              business, not a template.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-200 border border-zinc-200">
            {[
              { k: "5+", v: "Years experience" },
              { k: "50+", v: "Brands served" },
              { k: "12M+", v: "Ad spend managed" },
              { k: "4.9★", v: "Client rating" },
            ].map((s) => (
              <div key={s.v} className="bg-white p-6 lg:p-8">
                <div className="font-display text-4xl lg:text-5xl text-zinc-900 tracking-tighter">
                  {s.k}
                </div>
                <div className="mt-2 text-xs font-bold uppercase tracking-widest text-zinc-500">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
